import { render, staticRenderFns } from "./SeoItem.vue?vue&type=template&id=a1122d16"
import script from "./SeoItem.vue?vue&type=script&lang=js"
export * from "./SeoItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports